import type { FormRuntime } from "../runtime";
import type { FormValidationResult } from "./form-session";

export function validationResult(runtime: Pick<FormRuntime, "errors">): FormValidationResult {
	const messages = new Set<string>();

	for(const error of runtime.errors) {
		const message = error.message ?? "Invalid value";
		messages.add(message);
	}

	return {
		valid: runtime.errors.length === 0,
		messages: [...messages]
	};
}
